// extracted by mini-css-extract-plugin
module.exports = {"post-author":"PostAuthor_post-author__1ea1x"};